export namespace ContentType {
    export const PlainText = "text/plain";

    export const HtmlText = "text/html";

    export const HtmlTextUtf8 = "text/html; charset=\"utf-8\"";

    export const EmailMessage = "message/rfc822";

    export const MultipartRelated = "multipart/related";
    export const MultipartMixed = "multipart/mixed";
    export const MultipartEncrypted = "multipart/encrypted";

    export const Json = "application/json";

    export const PgpArmoured = "application/x-pgp-encrypted";
    export const PgpBinary = "application/pgp-encrypted";

    export const PgpMultipartSigned = "multipart/signed";
    export const PgpSignature = "application/pgp-signature";
    export const PgpKeys = "application/pgp-keys";
    export const PgpEncrypted = "application/pgp-encrypted";

    export const BinaryStream = "application/octet-stream";
}